import React from 'react';

import {
  withRouter
} from 'react-router';

import PropTypes from 'prop-types';

import VettingLeftArrow from '../Svg/VettingLeftArrow';

import './VettingBack.css';

const VettingBack = (props) => {

  const gotoUrl = () => {
    props.history.push(props.backUrl);
  };

  return(
    <div
      className="vetting-back-button-wrapper"
      onClick={gotoUrl}>

      <VettingLeftArrow/>

      <span
        style={{ marginLeft: '8px' }}>
        Back
      </span>
    </div>
  );
};

VettingBack.propTypes ={
  backUrl: PropTypes.string
};

export default withRouter(VettingBack);